
import { defineComponent } from 'vue'
import SwitchLocale from '@/components/SwitchLocale.vue'
import { userApi } from '@/api/user'
import snackbarStore from '@/store/snackbarStore'
import { handleAxiosException } from '@/api'

export default defineComponent({
  name: 'AccountActivation',
  components: {
    SwitchLocale,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async validateAccount() {
      this.loading = true
      try {
        await userApi.activateAccount(this.token)
        this.$router.push({ name: 'Login' })
      } catch (err) {
        snackbarStore.setError(this.$t(handleAxiosException(err)) as string)
      } finally {
        this.loading = false
      }
    },
    isTrot(): boolean {
      return !!process.env.VUE_APP_IS_TROT
    },
  },
  mounted() {
    this.validateAccount()
  },
})
